module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_LV-c4a2c13f40d81a77033700d32316a9ed.svg";